import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import feature1 from "../assets/images/feature-1.png";
import feature2 from "../assets/images/feature-2.png";
import feature3 from "../assets/images/feature-3.png";
import feature4 from "../assets/images/feature-4.png";
import { Button } from "antd";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import styled from "styled-components";
import { green } from "../constants/colors";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 3,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 767, min: 250 },
    items: 2,
    slidesToSlide: 1,
  },
};

const sliderItems = [
  {
    image: feature1,
    alt: "feature 1",
    text: "PKR 25,000.00",
    description: "Toyota Corolla",
  },
  {
    image: feature2,
    alt: "feature 2",
    text: "PKR 30,000.00",
    description: "Honda Civic",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "PKR 35,000.00",
    description: "Ford Focus",
  },
  {
    image: feature4,
    alt: "feature 4",
    text: "PKR 40,000.00",
    description: "Chevrolet Malibu",
  },
  {
    image: feature1,
    alt: "feature 1",
    text: "PKR 25,000..00",
    description: "Toyota Corolla",
  },
  {
    image: feature2,
    alt: "feature 2",
    text: "PKR 30,000.00",
    description: "Honda Civic",
  },
  {
    image: feature3,
    alt: "feature 3",
    text: "PKR 35,000.00",
    description: "Ford Focus",
  },
  {
    image: feature4,
    alt: "feature 4",
    text: "PKR 40,000.00",
    description: "Chevrolet Malibu",
  },
];

const CustomButtonGroupContainer = styled.div`
  position: absolute;
  top: -80px;
  right: 50px;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
  @media (max-width: 800px) {
    transform: none;
    top: -50px;
    right: 20px;
  }
`;

const CustomButton = styled(Button)`
  background-color: transparent;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  font-size: 20px;
  color: lightgray !important;
  padding: 5px !important;
  color: #333;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${green} !important;
    border-color: ${green} !important;
    color: black !important;
  }
`;

const CustomButtonGroup = ({ next, previous }) => {
  return (
    <CustomButtonGroupContainer className="custom-button-group">
      <CustomButton onClick={previous} className="custom-prev-button">
        <MdOutlineArrowBackIos />
      </CustomButton>
      <CustomButton onClick={next} className="custom-next-button">
        <MdOutlineArrowForwardIos />
      </CustomButton>
    </CustomButtonGroupContainer>
  );
};

const SlideContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: center;
  :hover & {
    cursor: pointer;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 93%;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #eee;
  padding: 10px;
  background: white !important;
  &:hover {
    border-color: gray; /* Replace 'green' with your desired color */
  }
`;

const SlideImage = styled.img`
  width: 100%;
  height: 330px;
  display: block;
  border-radius: 10px;
  @media (max-width: 800px) {
    height: 230px;
  }
`;

const SlideContent = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 13px 0;
  width: 95% !important;
  margin: 0 auto;
`;

const LaunchedCarSlider = () => {
  const navigate = useNavigate();
  return (
    <div className="parent" style={{ position: "relative" }}>
      <Carousel
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={false}
        infinite={true}
        partialVisible={false}
        customButtonGroup={<CustomButtonGroup />}
        renderButtonGroupOutside={true}
        arrows={false} // Hide the default arrows
      >
        {sliderItems.map((item, index) => (
          <SlideContainer key={index}>
            <ImageWrapper className="group">
              <SlideImage src={item.image} alt={item.alt} />
              <SlideContent>
                <div>
                  <h3 className="text-[20px] font-bold">{item.text}</h3>
                  <p className="text-[17px] text-[#5e5e5e] font-[500]">
                    {item.description}
                  </p>
                </div>
                <div
                  onClick={() => navigate("/car-details")}
                  className="h-[40px] w-[40px] rounded-[100%] bg-[#faf8fb] group-hover:bg-customGreen text-[lightgray] group-hover:text-[black] flex justify-center items-center"
                >
                  <FaArrowRight />
                </div>
              </SlideContent>
            </ImageWrapper>
          </SlideContainer>
        ))}
      </Carousel>
    </div>
  );
};

export default LaunchedCarSlider;
